import Icon from '../components/Icon.vue'

Icon.register({
  icons: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M116.7 219.3l-96.8-99.8c-28-29-26.4-77.1 5-103.9 27.4-23.3 68.2-19.1 93.3 6.8l9.8 10.1 9.9-10.1c25.1-25.9 65.9-30.1 93.3-6.8 31.4 26.8 33.1 74.9 4.9 103.9l-96.8 99.8c-2.6 2.7-7.6 4.8-11.3 4.8-3.7 0-8.8-2.2-11.3-4.8zM260.6 319.8c15.1 0 27.4 12.3 27.4 27.5v0 137.3 0c0 15.1-12.3 27.4-27.4 27.5h-233.1c-15.1 0-27.4-12.3-27.4-27.4v0-137.3 0c0-15.2 12.3-27.5 27.5-27.5h0 48l7-14.2c3.7-9.8 15.2-17.8 25.6-17.8h0 71.7 0c10.5 0 22 8 25.6 17.8l7.1 14.2h48zM144 468c28.7 0 52-23.3 52-52s-23.3-52-52-52-52 23.3-52 52 23.3 52 52 52zM499.4 352.1c9.7 0 15.8 8.8 10.9 15.7l-92.4 138.9c-2.2 2.9-6.9 5.3-10.6 5.3-0.1 0-0.3 0-0.3 0-8 0-14.1-6.3-12.2-12.9l24.2-83h-62.3c-7.6 0-13.5-5.6-12.5-11.9l16.8-106.9c0.8-5.2 6.2-9.1 12.5-9.1h75.6c8.3 0 14.3 6.6 12.2 13.2l-22.4 50.8h60.6zM478.1 0.3c17.9-2.8 33.9 12.2 33.9 31.7v144.3c-0.3 26.3-28.8 47.7-64 47.7-35.3 0-64-21.5-64-48 0-26.5 28.7-48 64-48 4.5 0 11.6 0.8 16 1.7v-47.2l-112 17.2v108.6c-0.3 26.3-28.8 47.7-64 47.7-35.3 0-64-21.5-64-48 0-26.5 28.7-48 64-48 4.5 0 11.6 0.8 16 1.7v-106.8c0-15.9 10.9-29.4 25.5-31.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/icons.js
// module id = 1477
// module chunks = 0